// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"22cf53f4","845":"a7af5a29"}[chunkId] + ".chunk.js";
};